import "htmx.org"; // https://htmx.org/
import "@fontsource-variable/inter"; // https://fontsource.org/docs/
import "./js/packages/icons.js"; // https://lucide.dev/
import "./scss/index.scss";

import { initDemoTable } from "./js/scripts/dataTables.js";
import { autosizeTextareas } from "./js/scripts/autosizeTextareas.js";
import { collapser } from "./js/scripts/collapser.js";
import { feeToggleHandler } from "./js/scripts/feeToggle.js";
import { toggleDropdown } from "./js/scripts/dropdownMenu.js";
import { toggleToTop } from "./js/scripts/toTop.js";
import { sectionAnchors } from "./js/scripts/anchorLinks.js";
import { handleDialogs } from "./js/scripts/handleDialogs.js";
import { initSearchInputs } from "./js/scripts/search.js";
import { setupSectionButtons } from "./js/scripts/subNavigation.js";
import { setupLockButtons } from "./js/scripts/lockButton.js";
import { handleEscKey } from "./js/helpers/handleEscape.js";
import { escConfigs } from "./js/configs/escapeConfig.js";

// import { initFileHtmx } from "./js/scripts/fileAdded.js";

import { initRepeaterHtmx } from "./js/scripts/initRepeaterHtmx.js";
const notesRepeater = initRepeaterHtmx("simpleNote");
const vehicleRepeater = initRepeaterHtmx("vehicle");
const belongingsRepeater = initRepeaterHtmx("belongings");

window.addEventListener("DOMContentLoaded", () => {
    autosizeTextareas();
    collapser();
    feeToggleHandler();
    toggleToTop();
    sectionAnchors();
    handleDialogs();
    initSearchInputs();
    setupSectionButtons();
    setupLockButtons();
    initDemoTable();
});

window.addEventListener("scroll", () => {
    toggleToTop();
});

// TODO - This doesn't catch all events correctly

document.addEventListener("keydown", (event) => {
    // Loop through each config
    Object.keys(escConfigs).forEach((key) => {
        handleEscKey(event, escConfigs[key]);
    });
});
